export default __webpack_public_path__ + "static/media/toboggan.0b33bafc.png";